import styled from "styled-components";

export const CreativeSparkWrapper = styled.div``